import { ButtonRenderProps, ButtonProps } from "sprint-common-web";

import { ClearSelectedOrderRequestsButton } from "./actions/ClearSelectedOrderRequestsButton";
import { PinOrderRequestsButton } from "./actions/PinOrderRequestsButton";
import {
    SetOrderRequestListingColumnsConfigButton,
    SetOrderRequestListingColumnsConfigButtonProps
} from "./config/SetOrderRequestListingColumnsConfigButton";
import { OrderRequestListingFilters } from "./hooks/useOrderRequestListingFilters";
import { SendMultipleOrderRequestsToCloudButton } from "./sending/send-to-cloud/SendMultipleOrderRequestsToCloudButton";
import { SendMultipleOrderRequestsToOnPremButton } from "./sending/send-to-on-prem/SendMultipleOrderRequestsToOnPremButton";

interface CreateOrderListingButtonsProps {
    filters: OrderRequestListingFilters;
    setPageSize(pageSize: number): void;
}

type OrderListingButtons =
    | ButtonRenderProps<ButtonProps>
    | ButtonRenderProps<SetOrderRequestListingColumnsConfigButtonProps>;

export const createOrderRequestListingButtons = (props: CreateOrderListingButtonsProps): OrderListingButtons[] => {
    const { filters, setPageSize } = props;

    const sendMultipleOrderRequestToCloud: ButtonRenderProps<ButtonProps> = {
        render: SendMultipleOrderRequestsToCloudButton
    };

    const sendMultipleOrderRequestToOnPrem: ButtonRenderProps<ButtonProps> = {
        render: SendMultipleOrderRequestsToOnPremButton
    };

    const clearSelectedOrderRequestsButton: ButtonRenderProps<ButtonProps> = {
        render: ClearSelectedOrderRequestsButton
    };

    const pinOrderRequestsButton: ButtonRenderProps<ButtonProps> = {
        render: PinOrderRequestsButton
    };

    const setOrderRequestListingColumnsConfigButton: ButtonRenderProps<SetOrderRequestListingColumnsConfigButtonProps> = {
        render: SetOrderRequestListingColumnsConfigButton,
        pageSize: filters.pageSize,
        setPageSize
    };

    return [
        sendMultipleOrderRequestToCloud,
        sendMultipleOrderRequestToOnPrem,
        pinOrderRequestsButton,
        setOrderRequestListingColumnsConfigButton,
        clearSelectedOrderRequestsButton
    ];
};
